<script>
    import Router from 'svelte-spa-router'
    import {replace, location, wrap} from 'svelte-spa-router'
    import {loggedUser, token, role} from './stores'

    import TopBar from './utils/top_bar.svelte'
    import SideBar from './utils/side_bar.svelte'
    import Login from './authentication/login.svelte'
    import ClientSelection from './authentication/client_selection.svelte'
    import EquipmentSummary from './equipment_summary/equipment_summary.svelte'
    import SiloDetails from './silo_details/silo_details.svelte'
    import SiloEdit from './silo_edit/silo_edit.svelte'
    import Spinner from './utils/spinner.svelte'
    import MyAlerts from './my_alerts/alert_app.svelte'
    import Footer from "./utils/footer.svelte"
    import EditAlert from "./my_alerts/edit_alert.svelte"
    import UserList from "./users/UserList.svelte"
    import ProductTypesList from "./product_types/ProductTypesList.svelte"
    import OrganizationList from "./organizations/OrganizationList.svelte"

    import {getRef} from "./firestore";
    import {map} from "rxjs/operators";

    let initialized = false;
    let authenticated = false;
    let admin = false;

    role.subscribe(value => {
        admin = value === "admin";
    })

    function isAuthenticated() {
        return firebase.auth().currentUser
    }

    function isAdmin() {
        return admin;
    }

    const routes = {
        '/': Login,
        '/client': ClientSelection,
        '/equipment/:id/edit': wrap(SiloEdit, isAuthenticated),
        '/equipment/:id': wrap(SiloDetails, isAuthenticated),
        '/equipment': wrap(EquipmentSummary, isAuthenticated),
        '/alert/new': wrap(EditAlert, isAuthenticated),
        '/alert/:id': wrap(EditAlert, isAuthenticated),
        '/alerts': wrap(MyAlerts, isAuthenticated),
        '/users': wrap(UserList, isAdmin),
        '/productTypes': wrap(ProductTypesList, isAdmin),
        '/organizations': wrap(OrganizationList, isAdmin)
    };

    firebase.auth().onAuthStateChanged((user) => {
        if (user) {
            loggedUser.set(user);

            firebase.auth().currentUser.getIdToken().then(ftoken => {
                token.set(ftoken);
            })

            getRef(firebase.firestore().doc("users/" + firebase.auth().currentUser.uid)).pipe(
                map(user => {
                    role.set(user.role.id)
                    if(user.client !== null)
                        return user.client;
                    else
                        throw new Error("Client is null");
                })
            ).subscribe(
                client => {},
                error => replace('/client')
            );
            authenticated = true;
        } else {
            token.set("");
            replace('/');
            authenticated = false;
        }
        initialized = true;
    });

    function conditionsFailed(event) {
        replace('/');
    }

    function routeLoaded(event) {
    }
</script>

{#if $location !== "/"}
    {#if initialized}
        <TopBar/>
    {/if}
    <SideBar/>
{/if}

{#if initialized && authenticated}
    <div class="page-wrapper">
        <Router {routes} on:conditionsFailed={conditionsFailed} on:routeLoaded={routeLoaded}/>
        <Footer/>
    </div>
{:else if initialized && !authenticated}
    <Router {routes} on:conditionsFailed={conditionsFailed} on:routeLoaded={routeLoaded}/>
{:else}
    <Spinner/>
{/if}